import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import DraggableWrapper from "../DraggableWrapper";
import { setClassificationsTabOpen } from "../../../../redux/actions/index";
import { Tabs } from "antd";
import AnnotationNavigation from "./AnnotationNavigation";
import BookmarkList from "../BookmarkList";
import ExportContentModal from "./ExportContentModal";

const limits = {
    minWidth: 300,
    minHeight: 450,
    maxWidth: 1000,
    maxHeight: 650,
}; //These need to correspond to the values in the css class draggableWrapper and &__tabContainer!

const ContentNavigation = ({
    windowDimensions,
    setLabelWindowOpen,
    labelWindowOpen,
    setUpdatingID,
    setBookmarksAndAnnotationsWindowOpen,
    markerToolActive,
    exportWindowOpen,
    setExportWindowOpen,
}) => {
    const dispatch = useDispatch();

    const customDimensionsRef = useRef({ width: 500, height: limits.minHeight });

    const title = (
        <div className="inspectRail__BookmarkList__Title">
            <p>Bookmarks and Annotations</p>
        </div>
    );

    const closeNavigator = () => {
        dispatch(setClassificationsTabOpen(false));
        setBookmarksAndAnnotationsWindowOpen(false);
    };

    const changeActiveTab = (activeKey) => {
        if (activeKey !== "Classifications") {
            dispatch(setClassificationsTabOpen(false));
        }
    };

    const content = (
        <div className="inspectRail__Detections inspectRail__tabContainer">
            <Tabs
                className="draggable-tabs inspectRail__tabContainer"
                defaultActiveKey={"Bookmarks"}
                destroyInactiveTabPane
                onChange={(activeKey) => changeActiveTab(activeKey)}>
                <Tabs.TabPane
                    tab="Annotations"
                    key="Annotations"
                    className="inspectRail__tab inspectRail__tabContent">
                    <AnnotationNavigation setDisplayDownloadModal={setExportWindowOpen} />
                </Tabs.TabPane>
                <Tabs.TabPane
                    tab="Bookmarks"
                    key="Bookmarks"
                    className="inspectRail__tab inspectRail__tabContent">
                    <BookmarkList
                        setDisplayDownloadModal={setExportWindowOpen}
                        setLabelWindowOpen={setLabelWindowOpen}
                        labelWindowOpen={labelWindowOpen}
                        setUpdatingBookmarkID={setUpdatingID}
                        markerToolActive={markerToolActive}
                        inResizeDraggable
                    />
                </Tabs.TabPane>
            </Tabs>
        </div>
    );

    return (
        <>
            <ExportContentModal
                displayModal={exportWindowOpen}
                closeModal={() => setExportWindowOpen(false)}
            />
            <DraggableWrapper
                content={content}
                title={title}
                windowDimensions={windowDimensions}
                closeAction={closeNavigator}
                customDimensionsRef={customDimensionsRef}
                customDimensions={{ width: customDimensionsRef.current.width, height: customDimensionsRef.current.height }}
                limits={limits}
                isResizable
                x={12}
                y={11}
            />
        </>
    );
};

export default ContentNavigation;
